import walidacjaModelu from '@components/form/validation/field/model'
import validated from '@components/form/validation/validated'

const model = { t: 'Model', name: 'model', hint: { url: '/model_all/truck', deps: ['marka'], cache: 'truck-model-all', exact: true }}

export default validated(model, walidacjaModelu)